import request from '@/utils/request'
import onlyNasFileUploadUseRequest from '@/utils/onlyNasFileUploadUseRequest'


export function getFeedBackMsg(){
    return request({
        url:'/api/FeedBack/IsShowFeeBackMsg',
        method:'post',
    })
}


export function GetFeeBackType(){
    return request({
        url:'/api/FeedBack/GetFeeBackType',
        method:'post',
    })
}

export function addFeedback (param) {  //反馈系统 添加反馈
    return request({
        url: `/api/FeedBack/Add`,
        method: 'Post',
        data: param
    })
}
export function editFeedback (param) {  //反馈系统 添加反馈
    return request({
        url: `/api/FeedBack/Edit`,
        method: 'Post',
        data: param
    })
}
export function getFeedbackList (param) {  //反馈系统 添加反馈
    return request({
        url: `/api/FeedBack/List`,
        method: 'Post',
        data: param
    })
}

export function getFeedbackById (id) {  //反馈系统 添加反馈
    return request({
        url: `/api/FeedBack/Get?id=${id}`,
        method: 'Post',
    })
}

export function replyAdd (FeedBackId,Remark) {  //反馈系统列表添加评论
    return request({
        url: `/api/FeedBack/ReplyAdd?FeedBackId=${FeedBackId}&Remark=${Remark}`,
        method: 'Post',
    })
}

export function getReplyList (FeedBackId) {  //反馈系统列表-评论详情
    return request({
        url: `/api/FeedBack/GetReplyList?FeedBackId=${FeedBackId}`,
        method: 'Post',
    })
}

export function feedBackRightRemaining () {  //剩余优先反馈次数
    return request({
        url: `/api/FeedBack/FeedBackRightRemaining`,
        method: 'Post',
    })
}
